import React, { Component } from "react";
import "./stylesheets/incentive.css";
import HeaderBack from "../../../components/backoffice/headerback/HeaderBack";
import {
  getBackSiteid,
  getBackJobsIncentive,
  getUpdateIncentive,
  getSubmitIncentive,
  getBackJobsSubmitIncentiveType,
} from "../../../modules/serverCall";
import "react-datepicker/dist/react-datepicker.css";
import BootstrapTable from "react-bootstrap-table-next";
import Moment from "moment";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import DatePicker from "react-datepicker";
import {
  AiOutlineDoubleLeft,
  AiOutlineDoubleRight,
  AiOutlineCheckCircle,
} from "react-icons/ai";
import { Button, Dropdown } from "react-bootstrap";
import cellEditFactory, { Type } from "react-bootstrap-table2-editor";
import overlayFactory from "react-bootstrap-table2-overlay";

export default class Incentive extends Component {
  constructor(props) {
    super(props);

    this.state = {
      Incentivedetails: [],
      expanded: [0, 1],
      currnetmonthdata: new Date(),
      statusId: "type1",
      selectedStatus: "Incentives (Formula)",
      siteId: 0,
      selectedSite: "Site Id",
      listSiteId: "",
      submitbtn: false,
      loading: false,
      loadingData: "No data found",
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    const accesstokendata = localStorage.getItem("access_token");
    const readData = JSON.parse(accesstokendata);
    const userId = readData.userdata.user_id;
    var sendData = {
      userid: userId,
    };
    const fetchsiteid = async () => {
      const responsesites = await getBackSiteid(sendData);
      const datarespsites = await responsesites;
      var siteIdArr = [];
      for (var i = 0; i < datarespsites.length; i++) {
        var siteId = {};
        siteId.key = datarespsites[i].SiteID;
        siteId.value = datarespsites[i].SiteName;
        siteIdArr.push(siteId);
      }
      this.setState({
        listSiteId: siteIdArr,
        selectedSite: siteIdArr[0].value,
        siteId: siteIdArr[0].key,
      });
    };
    fetchsiteid();
  }

  handleInputFetch = (event) => {
    var submitbtn = false;
    var loadingData = "No data Found";
    this.setState({
      loading: true,
      loadingData: "Loading",
    });
    var dateData = this.state.currnetmonthdata;
    var monthData = dateData.getMonth();
    var year = dateData.getFullYear();
    const siteId = this.state.siteId;
    const statusId = this.state.statusId;
    var sendData = {
      month: monthData + 1,
      year: year,
      site_id: siteId,
      status_id: statusId,
    };
    const fetchIncentivedetails = async () => {
      const responseIncentive = await getBackJobsIncentive(sendData);
      const datarespIncentive = await responseIncentive;
      const responseSubmitIncentive = await getBackJobsSubmitIncentiveType(
        sendData
      );
      const datarespSubmitIncentive = await responseSubmitIncentive;

      if (datarespIncentive.length > 0) {
        // const filtered = datarespIncentive.filter(obj => {
        //   return obj.ShowSubmit === true;
        // });
        // if(filtered.length >0){
        //   submitbtn = filtered[0].ShowSubmit;
        // }
      } else {
        loadingData = "No data found";
      }
      submitbtn = datarespSubmitIncentive.ShowSubmit;
      this.setState({
        Incentivedetails: datarespIncentive,
        submitbtn: submitbtn,
        loading: false,
        loadingData: loadingData,
      });
    };
    fetchIncentivedetails();
  };

  handleDropdown = (key, event) => {
    this.setState({
      selectedStatus: event.target.innerHTML,
      statusId: key,
      Incentivedetails: [],
      submitbtn: false,
    });
  };

  handleDropdownSite = (key, event) => {
    this.setState({
      selectedSite: event.target.innerHTML,
      siteId: key,
      Incentivedetails: [],
      submitbtn: false,
    });
  };

  handleInputChange = (event) => {
    this.setState({
      currnetmonthdata: event,
      Incentivedetails: [],
      submitbtn: false,
    });
  };

  // priceFormatter = event => {
  // if(event === 0){
  //   return '';
  // }else{
  //   return parseFloat(event);
  // }
  // }

  handleactionFormater = (event) => {
    const MySwal = withReactContent(Swal);
    const accesstokendata = localStorage.getItem("access_token");
    const readData = JSON.parse(accesstokendata);
    const userId = readData.userdata.user_id;
    const JobID = event.JobID;

    console.log("event.IncentiveAmt", event.IncentiveAmt);

    var submitData = {
      JobTechnicianID: event.JobTechnicianID,
      IncentiveAmount: parseFloat(event.IncentiveAmt),
      Remarks: event.Remarks,
      ModifiedBy: userId,
      ModifiedDate: event.ModifiedDate,
    };

    const saveIncentive = async () => {
      const responsesites = await getUpdateIncentive(submitData, JobID);
      const collection = document.getElementsByClassName(
        "demo-row-odd" + event.JobTechnicianID + ""
      );
      collection[0].style.color = "black";
      // if(responsesites === 200){
      this.handleInputFetch();
      // }
    };
    if (
      event.IncentiveAmt !== null &&
      event.IncentiveAmt !== undefined &&
      event.IncentiveAmt !== "" &&
      !isNaN(event.IncentiveAmt) &&
      Number.isInteger(Number(event.IncentiveAmt))
    ) {
      saveIncentive();
    } else {
      MySwal.fire("<p>Amount should be numeric, an integer, and not empty<p>");
    }
  };

  handleSubmit = (event) => {
    const accesstokendata = localStorage.getItem("access_token");
    const readData = JSON.parse(accesstokendata);
    const userId = readData.userdata.user_id;
    var dateData = this.state.currnetmonthdata;
    var monthData = dateData.getMonth();
    var year = dateData.getFullYear();
    var Status = 60;
    var siteEom = {};
    if (this.state.statusId === "type1") {
      siteEom = "TYPE1";
    } else {
      siteEom = "TYPE2";
    }
    const permissionsdata = localStorage.getItem("permissions");
    const permissionsreadData = JSON.parse(permissionsdata);
    const filteredData = permissionsreadData.filter((obj) => {
      return (
        obj.PermissionCode === "VALIDATE_JOB" ||
        obj.PermissionCode === "AUTHORIZE_JOB"
      );
    });
    if (filteredData.length > 0) {
      if (filteredData[0].PermissionCode === "VALIDATE_JOB") {
        Status = 60;
      } else if (filteredData[0].PermissionCode === "AUTHORIZE_JOB") {
        Status = 90;
      }
    }
    var submitData = {
      SiteId: this.state.siteId,
      Month: monthData + 1,
      Year: year,
      Status: Status,
      ModifiedBy: userId,
      TypeOfEntry: siteEom,
    };
    const submitIncentive = async () => {
      const responsesites = await getSubmitIncentive(submitData);
      this.handleInputFetch();
    };
    var msg =
      "Once submitted, you will not be able to make any modifications. Are you sure you want to submit for the month?.";
    Swal.fire({
      title: "Are you sure?",
      text: msg,
      icon: "warning",
      showCancelButton: true,
      allowOutsideClick: false,
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      reverseButtons: true,
    }).then((result) => {
      if (result.isConfirmed) {
        submitIncentive();
      }
    });
  };

  render() {
    var currnetMonthData = this.state.currnetmonthdata;
    var currnetMonth = "";
    var columns = "";
    if (currnetMonthData === "") {
      currnetMonth = new Date();
    } else {
      currnetMonth = currnetMonthData;
    }
    var listSiteId = this.state.listSiteId;
    var listStatus = [
      { key: "type1", value: "Incentives (Formula)" },
      { key: "type2", value: "Incentives (Entry)" },
    ];

    if (this.state.statusId === "type2") {
      columns = [
        {
          dataField: "JobID",
          text: "Job #",
          editable: false,
        },
        {
          dataField: "StartDate",
          text: "Date",
          formatter: (cellContent, row) => {
            return Moment(row.StartDate).format("DD-MMM-YYYY");
          },
          editable: false,
        },
        {
          dataField: "LoginID",
          text: "Employee Id",
          editable: false,
        },
        {
          dataField: "DisplayName",
          text: "Name",
          editable: false,
        },
        {
          dataField: "JobType",
          text: "Job Type",
          editable: false,
        },
        {
          dataField: "JobDetails",
          text: "Job Details",
          editable: false,
        },
        {
          dataField: "IncentiveAmt",
          text: "Incentive",
          editorClasses: "editing-name",
          classes: "Incentiveamt",
          formatter: (cellContent, row) => {
            if (row.IncentiveAmt > 500) {
              return <span className="redClass">{row.IncentiveAmt}</span>;
            } else {
              return <span>{row.IncentiveAmt}</span>;
            }
          },
          editable: (cell, row, _rowIndex, colIndex) => {
            if (row.OnlyCasuals === false) {
              return true;
            } else {
              return false;
            }
          },
          // validator: (newValue, row, column,done) => {
          //   if (isNaN(newValue)) {
          //     return {
          //       valid: false,
          //       message: 'Amount should be numeric'
          //     };
          //   }
          //   return true;
          // },
          // formatter: this.priceFormatter,
        },
        {
          dataField: "Remarks",
          text: "Remarks",
          editorClasses: "editing-name",
          classes: "Remarkdata",
          editable: (cell, row, rowIndex, colIndex) => {
            if (row.ShowSave === true) {
              return true;
            } else {
              return false;
            }
          },
        },
        {
          dataField: "JobStatus",
          text: "Job Status",
          editable: false,
          formatter: (cellContent, row) => {
            if (row.JobStatus === "Validated" || row.JobStatus === "Approved") {
              return <span className="greenDataCol">{row.JobStatus}</span>;
            } else {
              return row.JobStatus;
            }
          },
          classes: (cell, row, rowIndex, colIndex) => {
            return "demo-row-odd" + row.JobTechnicianID;
          },
        },
        {
          text: "Action",
          isDummyField: true,
          editable: false,
          formatter: (cellContent, row) => {
            if (row.ShowSave === true) {
              return (
                <span className="saveBtnIn" title="Save">
                  <AiOutlineCheckCircle />
                </span>
              );
            }
          },

          events: {
            onClick: (e, column, columnIndex, row, rowIndex) => {
              if (row.ShowSave === true) {
                this.handleactionFormater(row);
              }
            },
          },
        },
      ];
    } else {
      columns = [
        {
          dataField: "JobID",
          text: "Job #",
        },
        {
          dataField: "StartDate",
          text: "Date",
          formatter: (cellContent, row) => {
            return Moment(row.StartDate).format("DD-MMM-YYYY");
          },
        },
        {
          dataField: "LoginID",
          text: "Employee Id",
        },
        {
          dataField: "DisplayName",
          text: "Name",
        },
        {
          dataField: "JobType",
          text: "Job Type",
        },
        {
          dataField: "JobDetails",
          text: "Job Details",
          editable: false,
        },
        {
          dataField: "IncentivePC",
          text: "Incentive Percentage ",
        },
        {
          dataField: "IncentiveAmt",
          text: "Incentive Amount",
          formatter: (cellContent, row) => {
            if (row.IncentiveAmt > 500) {
              return <span className="redClass">{row.IncentiveAmt}</span>;
            } else {
              return <span>{row.IncentiveAmt}</span>;
            }
          },
        },
        {
          dataField: "JobStatus",
          text: "Job Status",
          formatter: (cellContent, row) => {
            if (
              row.JobStatus === "Validated" ||
              row.JobStatus === "Approved" ||
              row.JobStatus === "HOApproved"
            ) {
              return <span className="greenDataCol">{row.JobStatus}</span>;
            } else {
              return row.JobStatus;
            }
          },
        },
      ];
    }

    var Incentive = this.state.Incentivedetails;
    return (
      <div>
        <HeaderBack />
        <div className=" container jobfilter mb-4 mt-4">
          <div className="headerfilter-inct">
            <div className="viewcalander">
              <DatePicker
                selected={currnetMonth}
                onChange={(date) => this.handleInputChange(date)}
                dateFormat="MMM yyyy"
                showMonthYearPicker
                className="input-date-data-in outLine font_size"
              />
            </div>

            <div className="filterbtnsite">
              <Dropdown onSelect={this.handleDropdownSite}>
                <Dropdown.Toggle
                  variant="warning"
                  className="font_size"
                  id="dropdown-basic"
                >
                  {this.state.selectedSite}
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  {listSiteId !== ""
                    ? listSiteId.map((item, indexdata) => {
                        return (
                          <Dropdown.Item
                            className="font_size"
                            key={indexdata}
                            eventKey={item.key}
                          >
                            {item.value}
                          </Dropdown.Item>
                        );
                      })
                    : ""}
                </Dropdown.Menu>
              </Dropdown>
            </div>
            <div className="filterbtn">
              <Dropdown onSelect={this.handleDropdown}>
                <Dropdown.Toggle
                  variant="info"
                  className="font_size"
                  id="dropdown-basic"
                >
                  {this.state.selectedStatus}
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  {listStatus.map((item, index) => {
                    return (
                      <Dropdown.Item
                        className="font_size"
                        key={index}
                        eventKey={item.key}
                      >
                        {item.value}
                      </Dropdown.Item>
                    );
                  })}
                </Dropdown.Menu>
              </Dropdown>
            </div>
            <div className="filterbtn">
              <Button
                variant="primary"
                className="font_size"
                onClick={this.handleInputFetch}
              >
                Fetch
              </Button>
            </div>
            {this.state.submitbtn === true ? (
              <div className="submiteditbtn-in">
                <button
                  type="button"
                  onClick={this.handleSubmit}
                  className="btnval btn btn-success font_size"
                >
                  Submit
                </button>
              </div>
            ) : (
              ""
            )}
          </div>
        </div>
        <div className="table-container-inct">
          {this.state.statusId === "type2" ? (
            <BootstrapTable
              classes="tabledata-inct"
              keyField="JobTechnicianID"
              id="tabledata"
              data={Incentive}
              columns={columns}
              overlay={overlayFactory({
                spinner: true,
              })}
              loading={this.state.loading}
              cellEdit={cellEditFactory({
                mode: "click",
                blurToSave: true,
                afterSaveCell: (oldValue, newValue, row, column) => {
                  const collection = document.getElementsByClassName(
                    "demo-row-odd" + row.JobTechnicianID + ""
                  );
                  collection[0].style.color = "red";
                },
              })}
              noDataIndication={this.state.loadingData}
            />
          ) : (
            <BootstrapTable
              classes="tabledata-inct"
              keyField="JobID"
              id="tabledata"
              data={Incentive}
              columns={columns}
              overlay={overlayFactory({
                spinner: true,
              })}
              loading={this.state.loading}
              noDataIndication={this.state.loadingData}
            />
          )}
        </div>
      </div>
    );
  }
}
